import React from 'react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@/components/ui/dropdown-menu';
import { Menu } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { NavItem } from './NavigationMenu';
import { NavigationLink } from './NavigationLink';

export interface NavigationMobileProps {
  items: NavItem[];
  activeKey?: string;
  onItemClick?: (key: string) => void;
  className?: string;
  /** Custom link component for routing (e.g., React Router Link) */
  linkComponent?: React.ElementType;
}

export const NavigationMobile: React.FC<NavigationMobileProps> = ({
  items,
  activeKey,
  onItemClick,
  className,
  linkComponent
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className={cn(
            "rounded-full text-white hover:bg-white/10 md:hidden",
            className
          )}
          type="button"
          aria-label="Menu"
        >
          <Menu className="size-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {items.map((item) => (
          <DropdownMenuItem 
            key={item.key} 
            asChild
            className={activeKey === item.key ? 'bg-sky-50' : ''}
          >
            <NavigationLink
              as={linkComponent}
              href={item.href}
              onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                if (!linkComponent) {
                  e.preventDefault();
                }
                onItemClick?.(item.key);
              }}
              aria-current={activeKey === item.key ? 'page' : undefined}
            >
              {item.label}
            </NavigationLink>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

NavigationMobile.displayName = 'NavigationMobile';
